import { useSingleType } from "./content";

/**
 * Textos gerais do site (capa, cabeçalho, rodapé e listagem de
 * empreendimentos), no single type `inicio`.
 */
export const INICIO_DEFAULTS = {
  heroLinha1: "Construímos lugares.",
  heroLinha2: "Inspiramos um jeito de viver.",
  heroCta: "Ver Empreendimentos ↗",
  heroImagem: null,
  marcaTagline: "Um novo jeito de viver",
  menuAbertura: "Abertura",
  menuEmpreendimentos: "Empreendimentos",
  menuInstitucional: "Institucional",
  menuPbqh: "PBQH",
  menuContato: "Contato",
  rodapeTexto: "Bivver Empreendimentos — Balneário Piçarras / SC · (47) 99167-4662",
  rodapeCopyright: "Bivver. Todos os direitos reservados.",
  empreendimentosTitulo: "Encontre seu imóvel no litoral catarinense",
  empreendimentosSubtitulo: "Balneário Piçarras · Camboriú",
  empreendimentosVazio:
    "Nenhum empreendimento encontrado com esses filtros. Tente outra combinação ou fale com a gente pelo WhatsApp.",
  filtroCidadeLabel: "Cidade / Região",
  filtroStatusLabel: "Status da obra",
  filtroDormitoriosLabel: "Dormitórios",
  filtroFinalidadeLabel: "Finalidade",
  filtroBotao: "Filtrar imóveis",
  pdpDiferenciais: "Diferenciais",
  pdpVideo: "Vídeo do Empreendimento",
  pdpFotos: "Fotos do Empreendimento",
  pdpPlantas: "Plantas Humanizadas",
  pdpPlantasNota:
    "* Mais plantas (outras tipologias e pavimentos) serão adicionadas assim que a Bivver enviar.",
  pdpPlantasVazio:
    "As plantas humanizadas e o PDF para download deste empreendimento ainda serão adicionados.",
  pdpObra: "Evolução da Obra",
  pdpObraNota:
    "* Percentual estimado — a Bivver deve atualizar este número conforme o andamento real da obra.",
  pdpProgressoPrefixo: "Progresso geral:",
  pdpProgressoSufixo: "concluído",
  pdpLocalizacao: "Localização & Arredores",
  pdpEnderecoPrefixo: "* Endereço:",
};

export function useInicio() {
  return useSingleType("/inicio", INICIO_DEFAULTS);
}
